import { Info, X } from "react-feather"
import ContentField from "../Content"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import cx from "classnames"

export const useDescriptionStore = create(
  immer((set) => ({
    isOpen: false,
    toggle: () =>
      set((state) => {
        state.isOpen = !state.isOpen
      }),
  }))
)
const FieldDescription = ({ description, className }) => {
  const { isOpen, toggle } = useDescriptionStore((state) => ({
    isOpen: state.isOpen,
    toggle: state.toggle,
  }))

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()
    toggle()
  }

  return (
    <div className={cx("flex items-center", className)}>
      <button type="button" onClick={handleClose}>
        <Info className="ml-4 h-6 w-6" />
      </button>

      {isOpen && (
        <div className="flex flex-col w-full absolute p-4 rounded-[1.5rem] rounded-br-none bottom-0 right-0 bg-brand-turquoise-300 popup-custom-width">
          <button type="button" className="self-end" onClick={handleClose}>
            <X className="h-6 w-6" />
          </button>
          <div>
            <ContentField className="mt-0 pt-0" field={description} />
          </div>
        </div>
      )}
    </div>
  )
}

export default FieldDescription
